import { render } from "./personal-info.vue?vue&type=template&id=b3148ff2"
import script from "./personal-info.vue?vue&type=script&lang=js"
export * from "./personal-info.vue?vue&type=script&lang=js"

import "./personal-info.vue?vue&type=style&index=0&id=b3148ff2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__